import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'l-ng-lmap',
  template: `
    <p>
      ng-lmap works!
    </p>
  `,
  styles: []
})
export class NgLmapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
